import { MainFlowData, MainFlowAction, MainFlowActionTypes } from "./types";

export const initialState: MainFlowData = {
  sourceList: {},
  contactValue: "",
  selectedEmailsList: [],
  isLoading: false,
};
const mainFlowReducer = (
  state = initialState,
  { type, payload }: MainFlowAction
) => {
  switch (type) {
    case MainFlowActionTypes.GET_EMAIL_LIST_FOR_MAIN_FLOW:
      return {
        ...state,
        selectedEmailsList: [],
      };

    case MainFlowActionTypes.SET_EMAIL_LIST_FOR_MAIN_FLOW:
      return {
        ...state,
        selectedEmailsList: payload,
      };

    case MainFlowActionTypes.GET_SOURCES:
      return {
        ...state,
        contactValue: "",
        sourceList: {},
      };
    case MainFlowActionTypes.SET_SOURCES:
      return {
        ...state,
        contactValue: payload.contactValue,
        sourceList: { ...payload.sources },
      };
    case MainFlowActionTypes.SET_BTN_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case MainFlowActionTypes.CLEAN_BTN_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
export default mainFlowReducer;
